<!--左边菜单-->
<template>
	<div class="lefMenu custom-scrollbar" v-show="showLeft">
		<customerTree :dataList="dataList" :openAbleMethod="openAbleMethod" :getNextMethod="getNextMethod"
		 class="treeBody hideBar" id="all" style="overflow-y:auto!important;">
			<template slot-scope="slotProps">
				<div :class="getNodeClass(slotProps.item)" :style="getTreeNodeStyle(slotProps.nowFloor)" @click="clickItem(slotProps.item,slotProps.openAble)">
					<span :class="getNameClassNameList(slotProps.item)" style="min-width: 0;">{{getLabelMethod(slotProps.item)}}</span>
					<imageView :imgNameList="groupOpenAbleIco" class="groupOpenAbleIco" :imgIndex="slotProps.openAble ? 0 : 1" v-if="slotProps.item.hasSonMenu == 1">
						
					</imageView>
				</div>
			</template>
		</customerTree>
	</div>
</template>

<script>
	import customerTree from '@/components/module/tree/customerTree.vue'
	import imageView from '@/components/module/universal/imageView.vue'
	export default {
		components: {
			customerTree,
			imageView,
		},
		props: {
			//数据源，可查看设备树或者啥的
			dataList: {
				type: Array,
				required: true,
			},
			//组是否可以选中，如果可以选中的话，点击会触发点击事件
			groupCheckAble: {
				type: Boolean,
				default: false
			},
			//默认选中的方法,接收到数据源的时候，会递归设备树，然后根据这个方法找到第一个符合条件的项，设置为选中项，但是会根据是否允许选中单位来做过滤，如果不允许选中单位组，返回true也无效
			autoSelectMethod: {
				type: Function,
				default (item, index) {
					if (item.hasSonMenu != 1) {
						return true
					}
					return false
				}
			},
			//判断是否为组的方法，默认是有下一级就算，根据具体业务具体覆盖
			isGroup: {
				type: Function,
				default (item) {
					return !isempty(item.next)
				}
			},
			//判断两个对象是否为同一个的方法，主要用于判断是否和当前选中项一样
			isSameItem: {
				type: Function,
				default (item, nowItem) {
					if (nowItem == undefined || item == undefined) {
						return item == nowItem
					}
					return JSON.stringify(item) == JSON.stringify(nowItem)
				}
			},
			//每一行的节点div的样式，主要用于不断往右边偏移
			getTreeNodeStyle: {
				type: Function,
				default (nowFloor) {
					return {
						'padding-left': 0.1 * (nowFloor + 1) + 'rem',
						'line-height': '.38rem',
						'height': '.38rem'
					}
				}
			},
			getIDMethod: {
				type: Function,
				default (item) {
					return item.id
				}
			},
			getLabelMethod: {
				type: Function,
				default (item) {
					return item.rightname
				}
			},
			getNextMethod: {
				type: Function,
				default (item, index) {
					return item.next
				}
			},
		},
		data() {
			return {
				hideName: false,
				nowCheckItem: undefined,
				openItems: {
					//哪些项是打开的
				},
				groupOpenAbleIco: ['leftMenu/open.png', 'leftMenu/close.png']
			}
		},
		created() {},
		mounted() {
			this.autoSelect(this.dataList)
		},
		destroyed() {},
		computed: {
			getImageList() {
				return (item, nowFloor) => {
					return ["menu/" + item.iconFile + ".png","menu/" + item.iconFile + "y.png"]
				}
			},
			getNodeClass() {
				return (slotPropsItem) => {
					return this.isSameItem(slotPropsItem, this.nowCheckItem) ? ['treeNodeSelected', 'treeNode'] : ['treeNode']
				}
			},
			getNameClassNameList() {
				//设置当前名字文本框的样式列表，额外添加选中时的样式
				return item => {
					if (this.nowCheckItem == undefined) {
						return []
					}
					if (!this.isSameItem(item, this.nowCheckItem)) {
						return []
					}
					return ["nowCheckItem"]
				}
			},
			getStateImageIndex() {
				return (item, openAble) => {
					// return this.isSameItem(item, this.nowCheckItem) ? 0 : 1
					return 0
				}
			},
			showLeft(){
				return this.$store.menuStore.state.showLeftMenu
			}
		},
		watch: {
			dataList(nv, ov) {
				this.autoSelect(nv)
			},
		},
		methods: {
			openAbleMethod(item) {
				//控制项目展开收起
				if (!this.openItems.hasOwnProperty(this.getIDMethod(item))) {
					//已经关着的不打开
					return false
				}
				return true
			},
			toggleOpen(item, openAble) {
				if (openAble) {
					this.$delete(this.openItems, this.getIDMethod(item))
				} else {
					this.$set(this.openItems, this.getIDMethod(item), true)
				}
			},
			clickItem(item, openAble) {
				this.toggleOpen(item, openAble)
				//单击事件
				var checkItem = undefined
				if (this.isGroup(item)) {
					if (this.groupCheckAble) {
						checkItem = item
					}
				} else {
					checkItem = item
				}
				if (checkItem == undefined) {
					return
				}
				this.nowCheckItem = checkItem
				this.$emit("checkItem", checkItem)
			},
			// 打开当前菜单的所有父级组
			openParentGroup(arr, nowSort) {
				for (let i = 0;i < arr.length;i++) {
					if (nowSort.indexOf(arr[i].sort) > -1 && !isempty(arr[i].next)) {
						this.toggleOpen(arr[i], false)
					}
					if(!isempty(arr[i].next)) {
						this.openParentGroup(arr[i].next, nowSort)
					}
				}
			},
			autoSelect(list) {
				var item = findTreeItem(list, this.autoSelectMethod)
				var item2 = findTreeItem(list, (item, index) => {
					if (item.hasSonMenu != 1) {
						return true
					}
					return false
				})
				item = item == undefined ? item2 : item
				if(item == undefined) {
					return
				}
				if (this.isGroup(item) && !this.groupCheckAble) {
					return
				}
				//选中第一个并且默认是打开的
				this.clickItem(item, false)
				var nowMenuSort = localStorage.getItem('nowMenuSort')
				if(nowMenuSort != undefined) {
					this.openParentGroup(list, nowMenuSort)
				}
			},
		}
	}
</script>

<style scoped>
	.treeBody {
		overflow: auto;
		height: calc(100% - .3rem);
	}

	.treeNode {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
		user-select: none;
		height: 0.3rem;
		white-space: nowrap;
		position: relative;
		transition: transform 1s ease;
	}
	
	.treeNode>span{
		color: #333333;
	}

	@keyframes donut-spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(180deg);
		}
	}

	.treeNode:hover .groupOpenAbleIco {
		animation: donut-spin 0.3s linear;
	}

	.treeNode:active {
		background-color: white;
	}

	.treeNode:hover {
		background-color: #EEEEEE;
	}
	
	.treeNodeSelected{
		background: #00A0E9!important;
	}
	
	.treeNodeSelected>span{
		color: #FFFFFF;
	}

	.groupOpenAbleIco {
		right: .1rem;
		position: absolute;
		width: .15rem;
	}

	.stateImage {
		width: .18rem;
		padding-right: .1rem;
	}

	.nowSelectImg {
		width: .1rem;
		padding-right: .16rem;
	}

	.lefMenu {
		background: #FFFFFF;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	
	.hideBar{
		height: auto;
	}
</style>
